import React from "react";
import { Link } from "react-router-dom";
import { Section, SectionTitle } from "../components/SectionTitle";
import ServiceCard from "../components/ServiceCard";
import { Button } from "../components/ui/button";
import SEO from "../components/SEO";
import { CORE_SERVICES } from "../lib/serviceData";
import { ArrowRight } from "lucide-react";

export default function Services() {
  return (
    <div>
      <SEO
        title="Our Services - Financial, Tax, Insurance & Legal"
        description="Explore HSA Service Hub's full range of services: financial planning, tax preparation, insurance coverage review, legal service coordination, and business support across the USA."
        keywords="financial services USA, tax services USA, insurance services USA, legal services coordination, business tax services"
        path="/services"
      />
      <section className="bg-[#0a2540] text-white py-20 md:py-28">
        <div className="max-w-7xl mx-auto px-6 lg:px-12 max-w-4xl">
          <div className="eyebrow text-[#d4af37] mb-3">Our Services</div>
          <h1 className="font-serif-hsa text-4xl sm:text-5xl lg:text-6xl font-bold leading-[1.05] mb-5">
            One Umbrella. Endless Possibilities.
          </h1>
          <p className="text-lg text-white/85 max-w-2xl">
            Explore the full range of services HSA Service Hub coordinates for individuals, families,
            and businesses across the United States.
          </p>
        </div>
      </section>

      <Section className="bg-white">
        <div className="grid md:grid-cols-2 gap-6">
          {CORE_SERVICES.map((s, i) => (
            <ServiceCard
              key={s.slug}
              icon={s.icon}
              title={s.title}
              description={s.description}
              points={s.points}
              href={`/services/${s.slug}`}
              accentGold={i % 2 === 1}
              testId={`services-page-card-${s.slug}`}
            />
          ))}
        </div>
      </Section>

      <section className="bg-[#f8f9fa] py-20">
        <div className="max-w-4xl mx-auto px-6 text-center">
          <h2 className="font-serif-hsa text-3xl sm:text-4xl font-semibold text-[#0a2540] mb-5">
            Not sure which service fits your situation?
          </h2>
          <p className="text-slate-600 mb-8">
            Schedule a no-obligation consultation. We will help you map your goals to the right services.
          </p>
          <Link to="/contact">
            <Button data-testid="services-cta-btn" className="bg-[#0a2540] hover:bg-[#1e6dd8] text-white rounded-full px-7 h-12">
              Book a Consultation <ArrowRight className="w-4 h-4 ml-2" />
            </Button>
          </Link>
        </div>
      </section>
    </div>
  );
}
